export default {"src":"/_next/static/media/product-no.d1f42aa3.svg","height":28,"width":34};